<div class="w-full flex justify-between items-center p-8 pb-4">
    <p class="text-white text-2xl">Seleccionar perfil de configuración</p>
    <button (click)="closeDialog()"><i class="fa-light fa-xmark text-3xl text-white"></i></button>
</div>
<div *ngIf="!isCustomConfiguration">
    <div class="p-8 pb-2">
        <div class="flex items-center p-4 bg-quaternary border border-tertiary rounded-button mb-4 w-full h-10 cursor-pointer"
            (click)="createProfile()">
            <i class="fa-light fa-circle-plus mr-2 text-white"></i>
            <p class="text-white">Crear perfil de configuración</p>
        </div>
        <div class="flex items-center p-4 bg-transparent border border-tertiary rounded-round mb-4 w-full h-10 cursor-pointer"
            (click)="openConfiguration()">
            <i class="fa-light fa-sliders mr-2 text-white"></i>
            <p class="text-white">Personalizado</p>
            <i class="fa-light fa-arrow-right mr-2 ml-auto text-white"></i>
        </div>
    </div>
    <div class="w-full bg-secondary border border-b-0 border-l-0 border-r-0 border-t-tertiary p-8">
        <div class="w-full">
            <app-searchbar class="" placeholder="Buscar"></app-searchbar>
        </div>
        <div class="h-[310px] overflow-auto pr-3 mt-6">

            <div class="flex justify-between items-center mb-3 h-10 rounded-container px-6 border border-tertiary"
                [ngClass]="{'bg-accent': selectedProfile === profile, 'bg-transparent': selectedProfile !== profile}"
                (click)="selectProfile(profile)" *ngFor="let profile of profiles">
                <p
                    [ngClass]="{'text-quaternary': selectedProfile === profile, 'text-white': selectedProfile !== profile}">
                    {{profile.name}}
                </p>
                <div class="flex">

                    <span class="pl-10 text-white hover:text-grey cursor-pointer"><i class="fal fa-eye"
                            style="margin-left: 10px;"></i></span>
                </div>
            </div>
        </div>
    </div>
</div>
<app-configure-telephone-line class="!m-0" *ngIf="isCustomConfiguration" [line]="isCustomConfiguration"
    (profileSettings)="getSettings($event)"></app-configure-telephone-line>
<div class="w-full bg-modalBlue h-[114px] flex items-center justify-end">
    <button *ngIf="isCustomConfiguration"
        class="rounded-button bg-transparent w-48 h-13 border border-accent cursor-pointer text-accent text-lg mr-9"
        (click)="closeConfiguration()">
        Volver
    </button>
    <button
        class="rounded-button bg-accent w-48 h-13 border border-tertiary cursor-pointer text-quaternary text-lg mr-9"
        (click)="saveProfile()">
        Aplicar cambios
    </button>
</div>